/** Consignas que piden al estudiante inferir/escribir — no revelar la etiqueta numérica. */
export function isVisualExerciseInstruction(instruction: string): boolean {
  const value = String(instruction || '').trim();
  if (!value) return true;
  return /complet|identific|escribe|numerador|denominador|cu[aá]nt|falta|representa|observa.*y/i.test(
    value,
  );
}
